module.exports = __webpack_public_path__ + "img/logo-vrjmof2023_white.837d714c.svg";